import React from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import {cardTypes} from '../../entities/cardType.entity'
import {Button} from './index'



export default function UICardType({state, methods, ...props}){
    const {cardType, hideUi} = state
    const types = Array.from(cardTypes,([name, val]) => val)
    function handleClick(e, type){
        e.preventDefault()
        methods.selectCardType(type)
        
    }
    return <div className="uiPanel">
        <div className="uiRow uiButtonRow">
            <div className="uiTypeRow">
                <div style={{gap:0, display: "flex"}}>
                {types.map(type => (
                <Button
                    key={type.name} 
                    active={type.name === cardType.name} 
                    onClick={(e) => handleClick(e, type.name)} value={type.name} />
                )
            )}
                </div>
                <div className="hideButton" onClick={methods.toggleUi} >
                    {hideUi ? (
                        <span>Modifica <FiEye style={{marginLeft: 5}}/></span>
                    ): <span>Nascondi <FiEyeOff style={{marginLeft: 5}}/></span>}
                </div>

            </div>
        {/*
            <button className="button uiButtonRow" onClick={(e) => handleClick(e, "basic")}>Base</button>
            <button className="button uiButtonRow" onClick={(e) => handleClick(e, "pro")}>Pro</button>
            <button className="button uiButtonRow" onClick={(e) => handleClick(e, "one edition")}>One Edition</button>
        */}
        </div>
    </div>
}
